export default __webpack_public_path__ + "static/media/AlliedServicesLebenswerkBusinessManagement1.8fae7ccb.png";